module.exports = __webpack_public_path__ + "img/Tsehay_logo_big.51c0a2bb.png";